<template>
  <div ref="modalDOM" class="modal fade" tabindex="-1" aria-hidden="true" :data-bs-backdrop="staticBackdrop ? 'static' : null">
    <div :class="`${modalSize ? modalSize : 'modal-xl'} modal-dialog modal-dialog-centered modal-dialog-scrollable`">
      <div class="modal-content">
        <!-- Header -->
        <div v-if="hasHeader" class="modal-header">
          <slot name="header"></slot>
          <button v-if="hasCloseButton" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Body -->
        <div v-if="!forceRerenderOnOpen || isBodyShown" class="modal-body">
          <slot></slot>
        </div>

        <!-- Footer -->
        <div v-if="hasFooter" class="modal-footer" style="display: block">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { setModal, unsetModal } from '../composables/useModal';

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  onOpen: {
    type: Function,
    default: () => {}
  },
  onClose: {
    type: Function,
    default: () => {}
  },
  hasHeader: {
    type: Boolean,
    default: true
  },
  hasFooter: {
    type: Boolean,
    default: true
  },
  hasCloseButton: {
    type: Boolean,
    default: true
  },
  /**
   * モーダル外をクリックした時にモーダルを閉じさせない(true)、閉じる(false)
   */
  staticBackdrop: {
    type: Boolean,
    default: false
  },
  // モーダルの開閉のたびにbody部分をレンダリングし直すかどうかを指定
  forceRerenderOnOpen: {
    type: Boolean,
    default: true
  },
  // モーダルのサイズを指定する(modal-sm, modal-xlなど)
  modalSize: {
    type: String,
    required: false
  }
});

const modalDOM = ref();

// モーダルの開閉ごとにbody部分を再レンダリングさせるための変数
const isBodyShown = ref(false);
onMounted(() => {
  setModal(
    props.name,
    async () => {
      isBodyShown.value = true;
      await props.onOpen();
    },
    async () => {
      isBodyShown.value = false;
      await props.onClose();
    },
    modalDOM.value
  );
});

onUnmounted(() => {
  unsetModal(props.name);
});
</script>
